import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import _ from 'lodash';

Object.defineProperty(Vue.prototype, '$_', {value: _});


Vue.config.productionTip = false,


    document.addEventListener("backbutton", onBackKeyDown, false);

function onBackKeyDown(e) {
    e.preventDefault();
    return
}


  new Vue({
    router,

    store,
    render: h => h(App)
}).$mount('#app')

